export interface VersesInfo {
  book: string;
  chapter: number;
  verse: number;
}

interface UserProgress {
  id: string;
  progressFrom: VersesInfo;
  progressTo: VersesInfo;
  status: number;
  created_at: number;
  user_id: string;
}

export const QURAN_SURAH = [
  { number: 1, name: "Al-Fatihah", ayahs: 7, juz: [1] },
  { number: 2, name: "Al-Baqarah", ayahs: 286, juz: [1, 2, 3] },
  { number: 3, name: "Aal-E-Imran", ayahs: 200, juz: [3, 4] },
  { number: 4, name: "An-Nisa", ayahs: 176, juz: [4, 5, 6] },
  { number: 5, name: "Al-Ma'idah", ayahs: 120, juz: [6, 7] },
  { number: 6, name: "Al-An'am", ayahs: 165, juz: [7, 8] },
  { number: 7, name: "Al-A'raf", ayahs: 206, juz: [8, 9] },
  { number: 8, name: "Al-Anfal", ayahs: 75, juz: [9, 10] },
  { number: 9, name: "At-Tawbah", ayahs: 129, juz: [10, 11] },
  { number: 10, name: "Yunus", ayahs: 109, juz: [11] },
  { number: 11, name: "Hud", ayahs: 123, juz: [11, 12] },
  { number: 12, name: "Yusuf", ayahs: 111, juz: [12, 13] },
  { number: 13, name: "Ar-Ra'd", ayahs: 43, juz: [13] },
  { number: 14, name: "Ibrahim", ayahs: 52, juz: [13] },
  { number: 15, name: "Al-Hijr", ayahs: 99, juz: [14] },
  { number: 16, name: "An-Nahl", ayahs: 128, juz: [14, 15] },
  { number: 17, name: "Al-Isra", ayahs: 111, juz: [15] },
  { number: 18, name: "Al-Kahf", ayahs: 110, juz: [15, 16] },
  { number: 19, name: "Maryam", ayahs: 98, juz: [16] },
  { number: 20, name: "Ta-Ha", ayahs: 135, juz: [16] },
  { number: 21, name: "Al-Anbiya", ayahs: 112, juz: [17] },
  { number: 22, name: "Al-Hajj", ayahs: 78, juz: [17] },
  { number: 23, name: "Al-Mu’minun", ayahs: 118, juz: [18] },
  { number: 24, name: "An-Nur", ayahs: 64, juz: [18, 19] },
  { number: 25, name: "Al-Furqan", ayahs: 77, juz: [19] },
  { number: 26, name: "Ash-Shu'ara", ayahs: 227, juz: [19, 20] },
  { number: 27, name: "An-Naml", ayahs: 93, juz: [20] },
  { number: 28, name: "Al-Qasas", ayahs: 88, juz: [20, 21] },
  { number: 29, name: "Al-Ankabut", ayahs: 69, juz: [21] },
  { number: 30, name: "Ar-Rum", ayahs: 60, juz: [21] },
  { number: 31, name: "Luqman", ayahs: 34, juz: [21] },
  { number: 32, name: "As-Sajda", ayahs: 30, juz: [21] },
  { number: 33, name: "Al-Ahzab", ayahs: 73, juz: [21, 22] },
  { number: 34, name: "Saba", ayahs: 54, juz: [22] },
  { number: 35, name: "Fatir", ayahs: 45, juz: [22] },
  { number: 36, name: "Ya-Sin", ayahs: 83, juz: [22, 23] },
  { number: 37, name: "As-Saffat", ayahs: 182, juz: [23] },
  { number: 38, name: "Sad", ayahs: 88, juz: [23] },
  { number: 39, name: "Az-Zumar", ayahs: 75, juz: [23, 24] },
  { number: 40, name: "Ghafir", ayahs: 85, juz: [24] },
  { number: 41, name: "Fussilat", ayahs: 54, juz: [24, 25] },
  { number: 42, name: "Ash-Shura", ayahs: 53, juz: [25] },
  { number: 43, name: "Az-Zukhruf", ayahs: 89, juz: [25] },
  { number: 44, name: "Ad-Dukhan", ayahs: 59, juz: [25] },
  { number: 45, name: "Al-Jathiya", ayahs: 37, juz: [25] },
  { number: 46, name: "Al-Ahqaf", ayahs: 35, juz: [26] },
  { number: 47, name: "Muhammad", ayahs: 38, juz: [26] },
  { number: 48, name: "Al-Fath", ayahs: 29, juz: [26] },
  { number: 49, name: "Al-Hujurat", ayahs: 18, juz: [26] },
  { number: 50, name: "Qaf", ayahs: 45, juz: [26] },
  { number: 51, name: "Adh-Dhariyat", ayahs: 60, juz: [26, 27] },
  { number: 52, name: "At-Tur", ayahs: 49, juz: [27] },
  { number: 53, name: "An-Najm", ayahs: 62, juz: [27] },
  { number: 54, name: "Al-Qamar", ayahs: 55, juz: [27] },
  { number: 55, name: "Ar-Rahman", ayahs: 78, juz: [27] },
  { number: 56, name: "Al-Waqia", ayahs: 96, juz: [27] },
  { number: 57, name: "Al-Hadid", ayahs: 29, juz: [27] },
  { number: 58, name: "Al-Mujadila", ayahs: 22, juz: [28] },
  { number: 59, name: "Al-Hashr", ayahs: 24, juz: [28] },
  { number: 60, name: "Al-Mumtahina", ayahs: 13, juz: [28] },
  { number: 61, name: "As-Saff", ayahs: 14, juz: [28] },
  { number: 62, name: "Al-Jumua", ayahs: 11, juz: [28] },
  { number: 63, name: "Al-Munafiqoon", ayahs: 11, juz: [28] },
  { number: 64, name: "At-Taghabun", ayahs: 18, juz: [28] },
  { number: 65, name: "At-Talaq", ayahs: 12, juz: [28] },
  { number: 66, name: "At-Tahrim", ayahs: 12, juz: [28] },
  { number: 67, name: "Al-Mulk", ayahs: 30, juz: [29] },
  { number: 68, name: "Al-Qalam", ayahs: 52, juz: [29] },
  { number: 69, name: "Al-Haqqah", ayahs: 52, juz: [29] },
  { number: 70, name: "Al-Ma'arij", ayahs: 44, juz: [29] },
  { number: 71, name: "Nuh", ayahs: 28, juz: [29] },
  { number: 72, name: "Al-Jinn", ayahs: 28, juz: [29] },
  { number: 73, name: "Al-Muzzammil", ayahs: 20, juz: [29] },
  { number: 74, name: "Al-Muddathir", ayahs: 56, juz: [29] },
  { number: 75, name: "Al-Qiyamah", ayahs: 40, juz: [29] },
  { number: 76, name: "Al-Insan", ayahs: 31, juz: [29] },
  { number: 77, name: "Al-Mursalat", ayahs: 50, juz: [29] },
  { number: 78, name: "An-Naba", ayahs: 40, juz: [30] },
  { number: 79, name: "An-Nazi'at", ayahs: 46, juz: [30] },
  { number: 80, name: "Abasa", ayahs: 42, juz: [30] },
  { number: 81, name: "At-Takwir", ayahs: 29, juz: [30] },
  { number: 82, name: "Al-Infitar", ayahs: 19, juz: [30] },
  { number: 83, name: "Al-Mutaffifin", ayahs: 36, juz: [30] },
  { number: 84, name: "Al-Inshiqaq", ayahs: 25, juz: [30] },
  { number: 85, name: "Al-Buruj", ayahs: 22, juz: [30] },
  { number: 86, name: "At-Tariq", ayahs: 17, juz: [30] },
  { number: 87, name: "Al-A'la", ayahs: 19, juz: [30] },
  { number: 88, name: "Al-Ghashiyah", ayahs: 26, juz: [30] },
  { number: 89, name: "Al-Fajr", ayahs: 30, juz: [30] },
  { number: 90, name: "Al-Balad", ayahs: 20, juz: [30] },
  { number: 91, name: "Ash-Shams", ayahs: 15, juz: [30] },
  { number: 92, name: "Al-Lail", ayahs: 21, juz: [30] },
  { number: 93, name: "Ad-Duhaa", ayahs: 11, juz: [30] },
  { number: 94, name: "Ash-Sharh", ayahs: 8, juz: [30] },
  { number: 95, name: "At-Tin", ayahs: 8, juz: [30] },
  { number: 96, name: "Al-'Alaq", ayahs: 19, juz: [30] },
  { number: 97, name: "Al-Qadr", ayahs: 5, juz: [30] },
  { number: 98, name: "Al-Bayyina", ayahs: 8, juz: [30] },
  { number: 99, name: "Az-Zalzalah", ayahs: 8, juz: [30] },
  { number: 100, name: "Al-Adiyat", ayahs: 11, juz: [30] },
  { number: 101, name: "Al-Qari'ah", ayahs: 11, juz: [30] },
  { number: 102, name: "At-Takathur", ayahs: 8, juz: [30] },
  { number: 103, name: "Al-Asr", ayahs: 3, juz: [30] },
  { number: 104, name: "Al-Humazah", ayahs: 9, juz: [30] },
  { number: 105, name: "Al-Fil", ayahs: 5, juz: [30] },
  { number: 106, name: "Quraish", ayahs: 4, juz: [30] },
  { number: 107, name: "Al-Ma'un", ayahs: 7, juz: [30] },
  { number: 108, name: "Al-Kawthar", ayahs: 3, juz: [30] },
  { number: 109, name: "Al-Kafiroon", ayahs: 6, juz: [30] },
  { number: 110, name: "An-Nasr", ayahs: 3, juz: [30] },
  { number: 111, name: "Al-Masad", ayahs: 5, juz: [30] },
  { number: 112, name: "Al-Ikhlas", ayahs: 4, juz: [30] },
  { number: 113, name: "Al-Falaq", ayahs: 5, juz: [30] },
  { number: 114, name: "An-Nas", ayahs: 6, juz: [30] },
];

export default UserProgress;
